export const ADD_TO_CART = "products/add_to_cart";
export const REMOVE_FROM_CART = "products/remove_from_cart";
